module.exports = __webpack_public_path__ + "img/image 007.61e86edc.png";